export enum FixingState {
  SOFT_CUTOFF,
  TRIGGERED,
  ACTIVE,
  HARD_CUTOFF,
  FIXING_HIT,
  COMPLETED,
}

export namespace FixingState {
  let elements = [
    FixingState.SOFT_CUTOFF,
    FixingState.TRIGGERED,
    FixingState.ACTIVE,
    FixingState.HARD_CUTOFF,
    FixingState.FIXING_HIT,
    FixingState.COMPLETED,
  ];
  let alias = "com.bcdfx.model.FixingState";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
